import * as actions from './FinancialPlanWrapperActions'
import * as PlanSelectionActionsNewWhatIfs from '../PlanSelectionNewWhatIfs/PlanSelectionNewWhatIfsActions';

const FinancialPlan = (state = {}, action) => {
    switch (action.type) {
        case actions.SET_FP_ID:
            return Object.assign({}, state, {
                [action.clientId]: {
                    fpId: action.fpId
                }
            })
        case PlanSelectionActionsNewWhatIfs.SET_SELECTED:
            if (action.fpId !== state[action.clientId].fpId) {
                // Prevent event to be dispatched while reducer is executing.
                setTimeout(() => {
                    const event = new CustomEvent('fpid_new_what_ifs_updated', {
                    detail: {
                        fpId: action.fpId,
                        clientId: action.clientId,
                    },
                    });
                    document.body.dispatchEvent(event);
                }, 0);
            }
            return Object.assign({}, state, {
                [action.clientId]: {
                    fpId: action.fpId
                }
            })
        default:
            return state
    }
}

export default FinancialPlan